import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import Analytics from '../../../base/wyn-analytics-module.js';
import {
  templateUrls
} from './../../../base/vars.js';
import UserHandler from './../../base/user.js';
import { EventHandler } from './../../../base/utils.js';

export default Backbone.View.extend({
  el: '.app',

  events: {},

  initialize() {
    $('.app').append(this.el);
    this.getTemplate();
  },

  getTemplate() {
    $.ajax({
      url: templateUrls.confirmation,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        EventHandler.triggerEvent('enroll_complete', {
          pageName: 'confirmation',
          addressType: Analytics.processAddressType(this.model.get('addresses.0.typeCode'))
        });
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },

  render() {
    this.$el.hide();
    this.$el.find('.app-step-container').empty();
    this.$el.html(this.template(this.model.toJSON()));
    if (Utils.validPromotion) {
      this.$el.find('.successful-action-container').show();
      this.$el.find('.standard-state-container').remove();
    }
    this.$el.show();
    this.url = this.$el.find('form').data('url');
    Utils.bindBackboneValidation(this);
    Utils.triggerFormChecks();
    UserHandler.renderUserData();
  }
});
